import React from 'react';
import { ArrowDown as ArrowDownIcon } from '@phosphor-icons/react';
import { BrandLogo } from '../BrandLogo';
import { clinicians } from '../../data/proposal';
export function CoverSection() {
  const [lead, ...rest] = clinicians;
  return <section id="cover" aria-labelledby="cover-title" className="slide relative flex w-full snap-start snap-always flex-col justify-between overflow-hidden px-6 py-8 sm:px-10 lg:px-14" data-id="element-55" data-mp="xo8yph2gykoz">
      <header className="mx-auto flex w-full max-w-[1240px] items-center justify-between gap-6 border-b border-white/10 pb-4" data-id="element-56" data-mp="nsec6av4k5gx">
        <BrandLogo width={118} height={26} className="bg-transparent" data-id="element-57" data-mp="epwodrztn4rt" />
        <p className="font-body text-[10px] uppercase tracking-[0.28em] text-secondary/70" data-id="element-58" data-mp="erpy5g5qe541">
          Snakker · Campaign proposal
        </p>
      </header>

      <div className="mx-auto grid w-full max-w-[1240px] items-center gap-10 lg:grid-cols-[1.05fr_0.95fr]" data-id="element-59" data-mp="294pj7osvrrip">
        <div data-id="element-60" data-mp="2d3yc6rg3jld7">
          <p className="font-body text-[11px] uppercase tracking-[0.28em] text-primary" data-id="element-61" data-mp="2d4py1ajw64qa">
            Turn every clinical case into a traffic builder
          </p>
          <h1 id="cover-title" className="mt-4 font-heading text-[2.4rem] leading-[0.98] text-white sm:text-5xl lg:text-6xl" data-id="element-62" data-mp="3se06mdl9spw">
            Filtek
            <br data-id="element-63" data-mp="dhp6y2d06lam" />
            Clinical Case
            <br data-id="element-64" data-mp="diqligt89px3" />
            <span className="text-primary" data-id="element-65" data-mp="di791fmcjtqg">Teasers</span>
          </h1>
          <p className="mt-5 font-heading text-lg text-secondary lg:text-xl" data-id="element-66" data-mp="3lyaah3mv8m6c">
            One clinician. One case. One reason to click.
          </p>
          <p className="mt-4 max-w-xl font-body text-base leading-relaxed text-white/65" data-id="element-67" data-mp="3vvewn3gpohn5">
            Turn the existing Filtek clinical case content into a series of short, standalone
            Snakker Teasers — built to attract HCPs across channels and drive them into the
            complete clinical case experience.
          </p>
          <a href="#opportunity" className="mt-6 inline-flex items-center gap-3 rounded-full bg-primary px-5 py-2.5 font-body text-xs font-semibold uppercase tracking-[0.14em] text-[#01332b] transition-transform hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-offset-2 focus-visible:ring-offset-background" data-id="element-68" data-mp="166w715s3vixz">
            The opportunity
            <ArrowDownIcon size={14} weight="bold" aria-hidden="true" data-id="element-69" data-mp="1s5sbfsogacb2" />
          </a>
        </div>

        <div className="relative" data-id="element-70" data-mp="ukmjgrot9eij">
          <div className="grid grid-cols-3 gap-2.5 opacity-70" data-id="element-71" data-mp="zhmrv994utct">
            {rest.map(clinician => <img key={clinician.id} src={clinician.portrait} alt="" className="aspect-[4/5] w-full rounded-lg object-cover object-top" data-id="element-72" data-mp="14h91l8pr5rgv" />)}
          </div>
          <figure className="relative -mt-20 ml-auto w-[62%] rounded-xl border border-primary/40 bg-[#02241e] p-2.5 shadow-[0_36px_70px_-30px_rgba(0,0,0,0.95)]" data-id="element-73" data-mp="brsemqkwj2s1">
            <img src={lead.portrait} alt={`Portrait of ${lead.name}`} className="aspect-[4/5] w-full rounded-lg object-cover object-top" data-id="element-74" data-mp="2u26d9llg4ah8" />
            <figcaption className="px-1 pb-0.5 pt-3" data-id="element-75" data-mp="2l0goyomv1rno">
              <p className="font-heading text-lg text-white" data-id="element-76" data-mp="2kz5ds3r35hmj">{lead.name}</p>
              <p className="font-body text-[11px] uppercase tracking-[0.16em] text-secondary/70" data-id="element-77" data-mp="2g13srda3n88f">
                {lead.credentials} · {lead.location}
              </p>
              <p className="mt-2 font-body text-sm leading-snug text-primary" data-id="element-78" data-mp="26bk7k0ywz2ae">“{lead.hook}”</p>
            </figcaption>
          </figure>
        </div>
      </div>

      <p className="mx-auto w-full max-w-[1240px] border-t border-white/10 pt-4 font-body text-[10px] uppercase tracking-[0.2em] text-white/35" data-id="element-79" data-mp="228e1oufprd4g">
        Each clinician becomes their own campaign
      </p>
    </section>;
}